(function () {
    var HERO = { supreme: null, prime: null };
    var SEL = {
        supreme: { body: "attack", headstock: "evolution" },
        prime: { body: "attack", headstock: "evolution" }
    };
    var HEADSTOCK_JSON = {
        megaladon: "headstock_shark",
        hammerhead: "headstock_hammerhead",
        evolution: "headstock_evolution"
    };
    var SERIES = ["supreme", "prime"];
    var RENDER_DEBOUNCE_MS = 250;
    var ENTER_RATIO = 0.35;
    var LEAVE_RATIO = 0.15;
    var SWITCH_HOLD_MS = 400;

    var active = null;
    var generation = 0;
    var renderTimer = null;
    var switchTimer = null;
    var mountToken = 0;
    var scriptsRequested = false;
    var heroRequest = null;
    var ratios = { supreme: 0, prime: 0 };

    function stageOf(series) {
        return document.querySelector('.eg-stage[data-series="' + series + '"]');
    }

    function hostOf(series) {
        var stage = stageOf(series);
        return stage ? stage.querySelector(".eg-render-host") : null;
    }

    function loadHeroData() {
        if (heroRequest) return heroRequest;
        var params = SERIES.map(function (name) {
            var stage = stageOf(name);
            return name + "code=" + encodeURIComponent(stage ? stage.dataset.productCode : "");
        }).join("&");
        heroRequest = fetch("/api/cms/electricGuitarImages?" + params, { credentials: "same-origin" })
            .then(function (res) { return res.ok ? res.json() : null; })
            .then(function (payload) {
                if (!payload) return null;
                HERO.supreme = payload.heroSupreme || null;
                HERO.prime = payload.heroPrime || null;
                return payload;
            })
            .catch(function () { return null; });
        return heroRequest;
    }

    function buildDesignData(series) {
        var src = HERO[series];
        if (!src || !src.length) return null;
        var sel = SEL[series];
        return src.map(function (row) {
            var out = {}, key;
            for (key in row) out[key] = row[key];
            var category = Number(row.category_id);
            if (category === 10) out.model_type = sel.body;
            out.property = (row.property || []).map(function (prop) {
                if (category !== 11 || prop.property_json_key !== "headstock_type") return prop;
                var copy = {}, k;
                for (k in prop) copy[k] = prop[k];
                copy.property_json_value = HEADSTOCK_JSON[sel.headstock] || prop.property_json_value;
                return copy;
            });
            return out;
        });
    }

    function ensureScripts() {
        if (scriptsRequested || window.__productViewScriptsLoading) return;
        scriptsRequested = true;
        window.__productViewScriptsLoading = true;
        var preconnect = document.createElement("link");
        preconnect.rel = "preconnect";
        preconnect.href = "https://cdn.jsdelivr.net";
        preconnect.crossOrigin = "anonymous";
        document.head.appendChild(preconnect);
        var integrity = {
            "https://cdn.jsdelivr.net/npm/babylonjs@9.26.2/babylon.js": "sha384-+fus+TAW1rgo3iodbRvVQqwYdYRsx28wW9Osdun763A03VRiyBsBQ/5kulgbLOEJ",
            "https://cdn.jsdelivr.net/npm/babylonjs-loaders@9.26.2/babylon.glTF2FileLoader.min.js": "sha384-jJtn8O77AsF2ehLax+MhrD3EzBP8CdnT1LKflLNwXL76ebTCn9R/QMKTQZJWU/oo"
        };
        [
            "https://cdn.jsdelivr.net/npm/babylonjs@9.26.2/babylon.js",
            "https://cdn.jsdelivr.net/npm/babylonjs-loaders@9.26.2/babylon.glTF2FileLoader.min.js",
            "/js/texture-variants.min.js",
            "/js/render-budget.min.js",
            "/js/fretboard-binding.min.js",
            "/js/product-view/product-data.min.js",
            "/js/part-spec.min.js",
            "/js/product-view/product-parts.min.js",
            "/js/product-view/product-renderer.min.js"
        ].forEach(function (src) {
            var script = document.createElement("script");
            if (integrity[src]) {
                script.integrity = integrity[src];
                script.crossOrigin = "anonymous";
            }
            script.src = src;
            script.async = false;
            script.setAttribute("fetchpriority", "low");
            document.head.appendChild(script);
        });
    }

    function showSpinner() {
        var screen = document.getElementById("productRenderLoadingScreen");
        if (!screen) return;
        screen.style.display = "";
        screen.style.transition = "";
        screen.style.opacity = "1";
    }

    function paintStage(series) {
        var target = hostOf(series);
        var template = document.getElementById("egRenderTemplate");
        if (!target || !template) return null;
        SERIES.forEach(function (name) {
            var host = hostOf(name);
            if (host) host.replaceChildren();
        });
        target.appendChild(template.content.cloneNode(true));
        if (typeof window.translateElement === "function") window.translateElement(target);
        var reset = target.querySelector("#productRenderReset");
        if (reset) {
            reset.addEventListener("click", function () {
                if (typeof window.resetProductRenderer === "function") window.resetProductRenderer();
            });
        }
        return target.querySelector("#productRenderCanvas");
    }

    function whenLaidOut(canvas, gen, tries, done) {
        if (gen !== generation) return;
        if (canvas.clientWidth > 0 && canvas.clientHeight > 0) return done();
        if (tries > 20) return done();
        requestAnimationFrame(function () { whenLaidOut(canvas, gen, tries + 1, done); });
    }

    function initWhenReady(designData, gen) {
        if (gen !== generation) return;
        if (typeof BABYLON === "undefined" ||
            typeof ProductRenderer === "undefined" ||
            typeof ProductRenderer.init !== "function" ||
            typeof window.initProductRenderer !== "function" ||
            !document.getElementById("productRenderCanvas")) {
            setTimeout(function () { initWhenReady(designData, gen); }, 100);
            return;
        }
        window.initProductRenderer(designData);
    }

    function disposeRenderer() {
        try {
            if (window.productResizeObserver && window.productResizeObserver.disconnect) {
                window.productResizeObserver.disconnect();
            }
            if (window.engine && window.engine.dispose) {
                window.engine.stopRenderLoop();
                window.engine.dispose();
            }
        } catch (err) {}
        window.engine = "";
    }

    function doRender() {
        if (!active) return;
        var designData = buildDesignData(active);
        if (!designData) return unmount();
        generation++;
        var gen = generation;
        var canvas = paintStage(active);
        if (!canvas) return;
        ensureScripts();
        whenLaidOut(canvas, gen, 0, function () { initWhenReady(designData, gen); });
    }

    function scheduleRender() {
        showSpinner();
        clearTimeout(renderTimer);
        renderTimer = setTimeout(doRender, RENDER_DEBOUNCE_MS);
    }

    function unmount() {
        if (!active) return;
        mountToken++;
        generation++;
        clearTimeout(renderTimer);
        clearTimeout(switchTimer);
        switchTimer = null;
        disposeRenderer();
        SERIES.forEach(function (name) {
            var stage = stageOf(name);
            var host = hostOf(name);
            if (host) host.replaceChildren();
            if (stage) stage.classList.remove("is-rendering");
        });
        active = null;
    }

    function mount(series) {
        if (active === series) return;
        ensureScripts();
        mountToken++;
        var token = mountToken;
        loadHeroData().then(function () {
            if (token !== mountToken) return;
            if (!HERO[series] || !HERO[series].length) return;
            if (ratios[series] < LEAVE_RATIO) return;
            if (active === series) return;
            unmount();
            active = series;
            SERIES.forEach(function (name) {
                var stage = stageOf(name);
                if (stage) stage.classList.toggle("is-rendering", name === series);
            });
            doRender();
        });
    }

    function decide() {
        var best = null;
        SERIES.forEach(function (name) {
            if (ratios[name] >= ENTER_RATIO && (!best || ratios[name] > ratios[best])) best = name;
        });
        if (active && ratios[active] < LEAVE_RATIO) unmount();
        if (!best || best === active) {
            clearTimeout(switchTimer);
            switchTimer = null;
            return;
        }
        clearTimeout(switchTimer);
        switchTimer = setTimeout(function () {
            switchTimer = null;
            if (ratios[best] >= ENTER_RATIO) mount(best);
        }, SWITCH_HOLD_MS);
    }

    function watchViewport() {
        if (!window.IntersectionObserver) return;
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                var name = entry.target.dataset.series;
                if (ratios.hasOwnProperty(name)) ratios[name] = entry.intersectionRatio;
            });
            decide();
        }, { threshold: [0, 0.05, LEAVE_RATIO, ENTER_RATIO, 0.6, 1] });
        SERIES.forEach(function (name) {
            var stage = stageOf(name);
            if (stage) observer.observe(stage);
        });
    }

    window.sharkEGSet = function (series, kind, value) {
        if (!SEL[series] || !value) return;
        SEL[series][kind] = value;
        if (series === active) scheduleRender();
    };

    document.addEventListener("DOMContentLoaded", watchViewport);

    window.addEventListener("pagehide", unmount);
})();
